import React, { Fragment, useRef, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@othermachines/react-form-kit';
import { Transition } from '@headlessui/react';

import ComponentLoader from './ComponentLoader';
import { FormButton } from '../../Elements';
import Menu from './Menu';
import { Switcher } from '../../EveryLayout';

import * as ProjectDetails from './ProjectDetails';

import {
  ContactInformation,
  contactInformationFields,
  Notification,
} from '../Shared';

import { fields as projectDetailsFields } from './ProjectDetails';

import {
  applyDefaultDisplay,
  applyDefaultLayout,
  applyGlobalDisplay,
  applyGlobalLayout,
} from '../lib';
import { useSubmitForm } from './lib';


const RequestAQuote = ({
  allowScroll,
  childCategories,
  contactValues,
  component,
  defaultValues,
  fields,
  formDetailRef,
  formExists,
  formName,
  formTopRef,
  setContactValues,
  topCategoryItem,
}) => {

  const notificationRef = useRef(null);
  const scrollToRef = useRef(null);
  const formRef = useRef(null);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [status, setStatus] = useState('');
  const [submissionComplete, setSubmissionComplete] = useState(false);

  const [displayForm, setDisplayForm] = useState(true);

  const preSubmit = () => {
    setDisplayForm(false);
  }

  const onSuccess = () => {
    // formRef.current.reset();
    // setContactValues({});
  };

  // TODO: refactor nameing
  const defaultFields = [...contactInformationFields, ...projectDetailsFields];

  const submitForm = useSubmitForm({
    contactDefaultValues: contactValues.current,
    contactInformationFields: defaultFields,
    defaultValues,
    fields,
    formName,
    onSuccess,
    preSubmit,
    setStatus,
    setSubmissionComplete,
    setDialogOpen,
    scrollToRef,
  });

  const {
    clearErrors,
    // control,
    formState,
    handleSubmit,
    onSubmit,
    register,
    reset,
    // setValue,
    // unregister,
    watch,
  } = submitForm;

  // watch() returns an array, rather than object, when an array of field names
  // is provided. Watch the fields we want to persist and convert the array to
  // an object.
  const watchFields = ['Full-name', 'Organization', 'Email', 'Phone', 'Preferred-contact-method', 'Description'];
  const currentContactValues = watch(watchFields);

  useEffect(() => {
    const hasValues = Object.values(currentContactValues).some((value) => value);
    if (hasValues) {
      const _currentContactValues = currentContactValues.reduce((acc, value, index) => {
        const key = watchFields[index];
        acc[key] = value;
        return acc;
      }, {});

      setContactValues(_currentContactValues);
    }
  }, [currentContactValues]);


  return (
    <>
      <Switcher className="pt-8">
        <section className="px-4 md:px-8">
          <div ref={scrollToRef} />
          <Menu
            allowScroll={allowScroll}
            childCategories={childCategories}
            topCategoryItem={topCategoryItem}
            />
        </section>

        <section className="px-4 md:px-8">
          <Notification
            title="Request a Quote submission"
            status={status}
            errorMessages={[]}
            submissionComplete={submissionComplete}
            open={dialogOpen}
            setOpen={setDialogOpen}
            ref={notificationRef}
          />

          {displayForm === false && (
            <div className="mx-auto py-8">
              <p className='text-center'>
                <FormButton
                  type="submit"
                  onClick={() => {
                    setDisplayForm(true);
                  }}
                >
                  Request another quote
                </FormButton>
              </p>
            </div>
          )}

          {displayForm && (
            <ThemeProvider
              applyDefaultDisplay={applyDefaultDisplay}
              applyDefaultLayout={applyDefaultLayout}
              applyGlobalDisplay={applyGlobalDisplay}
              applyGlobalLayout={applyGlobalLayout}
              theme={{
                Label: {
                  display: {
                    label: 'font-normal',
                  },
                },
                Legend: {
                  display: {
                    legendText: 'font-normal mb-4 border-b w-full'
                  },
                }
              }}
            >

              <form ref={formRef} onSubmit={handleSubmit(onSubmit)} className="mx-auto py-8">
                <div ref={formTopRef} />
                <input type="hidden" value={formName} name="Form" />

                <ContactInformation
                  register={register}
                  formState={formState}
                />

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 -translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-1"
                    show={formExists}
                  >
                    <div className="mt-6">
                      <div ref={formDetailRef} />

                      <ComponentLoader
                        component={component}
                        submitForm={submitForm}
                      />
                    </div>
                  </Transition>

                <div className="mt-6">
                  <ProjectDetails.Component submitForm={submitForm} />
                </div>

                <input type="hidden" value="" name="flywheel" />
                <div className='mt-4'>
                  <FormButton type="submit">
                    Submit
                  </FormButton>
                </div>

              </form>
            </ThemeProvider>
          )}


        </section>
      </Switcher>
    </>
  );
};

RequestAQuote.propTypes = {
  childCategories: PropTypes.array.isRequired,
  contactValues: PropTypes.object.isRequired,
  component: PropTypes.string.isRequired,
  defaultValues: PropTypes.object.isRequired,
  formDetailRef: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  formName: PropTypes.string.isRequired,
  formTopRef: PropTypes.object.isRequired,
  formExists: PropTypes.bool.isRequired,
  setContactValues: PropTypes.func.isRequired,
  topCategoryItem: PropTypes.object.isRequired,
};

export default RequestAQuote;
